import "./AboutHero.scss"

export const AboutHero = () => {
    return <div className="about-hero">
        <div className="title h1">Award-winning<br/>experts in the craft</div>
        <div className="subtitle">Since our inception in 2012, SpokenLayer has become THE premier thought leader in short-form audio creation and production. Partnering with top publishers and advertisers, like Conde Nast, General Mills, the Wall Street Journal, Audible, Group Nine, the Economist, Starbucks, Time, and Tribune, we have created over 320,000 episodes of content.</div>
    </div>
}